{
    "FileUpload_DragAndDrop": "Solte o ficheiro aqui ou clique para selecionar o ficheiro",
    "FileUpload_DropFileHere": "Solte o ficheiro aqui",
    "FileUpload_Accepted": "O ficheiro será aceito",
    "FileUpload_Rejected": "O ficheiro será rejeitado",
    "FileUpload_SelectedFile": "Ficheiro selecionado: {}",
    "FileUpload_Validation_OverMaxSize": "O tamanho do ficheiro excede o tamanho máximo permitido de {}",
    "FileUpload_Validation_MaxDimensions": "As dimensões do ficheiro excedem as dimensões máximas permitidas de {}x{}",
    "FileUpload_Validation_MinDimensions": "As dimensões do ficheiro estão abaixo das dimensões mínimas permitidas de {}x{}",
    "FileUpload_Validation_NotTransparent": "O fundo do ficheiro não é transparente",
    "NAME": "FileUploadLanguage"
}